<template>
  <el-dialog :title="priceData.id==null ? '新增电价' : '编辑电价'" :visible.sync="priceVisible" width="550px" :modal-append-to-body='false' :before-close="handleClose" :close-on-click-modal="false" center>
    <div class="from-body">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="auto" class="demo-ruleForm">
        <el-form-item label="电价时段" prop="stype">
          <el-select v-model="ruleForm.stype" placeholder="请选择" @input="onInput" style="width:300px;">
            <el-option label="尖" value="jian" />
            <el-option label="峰" value="feng" />
            <el-option label="平" value="ping" />
            <el-option label="谷" value="gu" />
            <el-option label="其他" value="other" />
          </el-select>
        </el-form-item>
        <el-form-item label="开始日期" prop="dayStart">
          <el-date-picker type="datetime" placeholder="选择日期" value-format="MM-dd HH:mm:ss" format="MM-dd HH:mm:ss" v-model="ruleForm.dayStart" style="width: 300px" clearable/>
        </el-form-item>
        <el-form-item label="截止日期" prop="dayEnd">
          <el-date-picker type="datetime" placeholder="选择日期" value-format="MM-dd HH:mm:ss" format="MM-dd HH:mm:ss" v-model="ruleForm.dayEnd" style="width: 300px" clearable/>
        </el-form-item>
        <el-form-item label="开始时间" prop="timeStart">
          <el-time-picker type="time" placeholder="选择时间" value-format="HH:mm" format="HH:mm" v-model="ruleForm.timeStart" style="width: 300px" clearable/>
        </el-form-item>
        <el-form-item label="截止时间" prop="timeEnd">
          <el-time-picker type="time" placeholder="选择时间" value-format="HH:mm" format="HH:mm" v-model="ruleForm.timeEnd" style="width: 300px" clearable/>
        </el-form-item>
        <el-form-item label="当前电价" prop="price">
          <el-input v-model="ruleForm.price" @input="onInput" style="width: 300px" clearable/>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      currentData:{},
      ruleForm: {
        id: null,
        project: null,
        stype: null,
        dayStart: null,
        dayEnd:null,
        timeStart: null,
        timeEnd:null,
        price:null
      },
      rules: {
        stype: [
          {
            required: true,
            message: "请设置电价时段",
            trigger: "blur",
          },
        ],
        dayStart: [
          {
            required: true,
            message: "请填写开始日期",
            trigger: "blur",
          },
        ],
         dayEnd: [
          {
            required: true,
            message: "请填写结束日期",
            trigger: "blur",
          },
        ],
        timeStart: [
          {
            required: true,
            message: "请填写开始时间",
            trigger: "blur",
          },
        ],
         timeEnd: [
          {
            required: true,
            message: "请填写结束时间",
            trigger: "blur",
          },
        ],
         price: [
          {
            required: true,
            message: "请填写电价",
            trigger: "blur",
          },
        ]
      },
    };
  },
  computed: {
    ...mapState(["buttonTextColor"]),
  },
  props: ["priceVisible","priceData","project"],
  watch: {
    priceVisible(newVal) {
      if (newVal) {
        this.ruleForm.project=this.project;
        this.ruleForm.id=this.priceData.id;
        this.ruleForm.stype=this.priceData.stype;
        this.ruleForm.dayStart=this.priceData.dayStart;
        this.ruleForm.dayEnd=this.priceData.dayEnd;
        this.ruleForm.timeStart=this.priceData.timeStart;
        this.ruleForm.timeEnd=this.priceData.timeEnd;
        this.ruleForm.price=this.priceData.price;
      }
    }
  },
  methods: {
    onInput() {
        this.$forceUpdate();
    },
    handleClose() {
      this.ruleForm={
        id: null,
        project: null,
        stype: null,
        dayStart: null,
        dayEnd:null,
        timeStart: null,
        timeEnd:null,
        price:null
      };
      this.$refs["ruleForm"].resetFields();
      this.$emit("handleClose");
    },
    //确定
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.request.electricityEdit(this.ruleForm).then((res) => {
              if (res.code==0) {
                this.$emit("priceList");
                this.handleClose();
              }
            });
        }
      });
    },
  },
};
</script>


<style scoped>
.from-body {
  padding: 0 60px;
  box-sizing: border-box;
}
</style>